





































import { defineComponent, ref } from '@vue/composition-api'
import { PropType } from 'vue';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { RowType } from '~/types/solepro/PageBuilder';
import VideoBackground from '~/mixins/solepro/VideoBackground.vue';
import { GenericObjectType } from '~/utils/types';
import { trackPageBuilderButton } from '~/helpers/trackings/24orepro/components';
import BrightcoveVideo from '../BrightcoveVideo.vue';
import { useAnimationControl } from '~/composables';

export default defineComponent({
    name: "Events",
    mixins: [PageBuilderComponent, VideoBackground],
    props: {
        node: {
            type: Object as PropType<RowType>,
            required: true
        },
        customProps: {
            type: Object as PropType<GenericObjectType>,
            default: () => { return {} }
        }
    },
    components: {
        PageBuilderComponent,
        BrightcoveVideo
    },
    setup(props) {
        //@TODO brightcove poster
        const content = props.node;
        // 1. Rimuoviamo il prefisso 'mp4:' e puliamo gli spazi
        let finalUrl = content.videoSrc.replace('mp4:', '')

        const cleanVideoUrl = finalUrl;
        const { isAnimationsPaused } = useAnimationControl()
        const videoDiv = ref(null)
        const hasParallax = content.enableParallax == '1' && content.backgroundImages != "" && content.backgroundImages != "{}";
        const isLink = !!content.soleProfessionistiUrl;
        const WrapperComponent = hasParallax ? () => import('~/components/Parallax.vue') : 'div'
        const isTrack = !!content.soleProfessionistiTrack;
        const hasIframe = content.videoSrc && !content.videoSrc.split('?')[0].endsWith('.mp4') && !content.videoSrc.includes('brightcove')
        let iframeSrc = content.videoSrc;
        if (hasIframe) {
            const params = 'autoplay=1&mute=1&controls=0&modestbranding=1&iv_load_policy=3'
            iframeSrc += iframeSrc.includes('?') ? '&' + params : '?' + params;
        }
        //@ts-ignore
        const textElement = content.children.find(el => el.contentType == 'text').DOMContent.innerHTML;
        const callbackFn = () => {
            if (content.target == '_blank') {
                window.open(content.soleProfessionistiUrl, content.target).focus();
            } else {
                location.href = `${content.soleProfessionistiUrl}`;
            }
        };
        const trackFunction = (e, callbackFn?: Function) => {
            e.preventDefault();
            trackPageBuilderButton(content.soleProfessionistiTrack, content.soleProfessionistiUrl, content.target ?? null, callbackFn);
        }
        const trackRow = (e) => isTrack && isLink ? trackFunction(e, callbackFn) : callbackFn()
        const isHovered = ref<Boolean>(false)
        const observer = ref<IntersectionObserver | null>(null);
        return {
            trackRow,
            WrapperComponent,
            content,
            hasIframe,
            iframeSrc,
            hasParallax,
            isContained: content.appearance == 'contained',
            isFullWidth: content.appearance == 'full-width',
            isHovered,
            textElement,
            videoDiv,
            isAnimationsPaused,
            observer,
            cleanVideoUrl,
        }
    },
    mounted() {
        const $th = this;
        $th.setupIntersectionObserver()

    },
    beforeDestroy() {
        // È importante pulire l'observer quando il componente viene distrutto
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    methods: {
        setupIntersectionObserver() {
            const options = {
                root: null, // usa la viewport del browser
                rootMargin: '0px 0px 400px 0px',
                threshold: 0.01
            };

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Il componente è visibile! Carichiamo il video
                        this.loadVideo();

                        // Una volta caricato, smettiamo di osservare
                        if (this.observer) {
                            this.observer.unobserve(entry.target);
                        }
                    }
                });
            }, options);

            // Inizia a osservare l'elemento videoDiv
            const target = this.$refs.videoDiv as HTMLElement;
            if (target) {
                this.observer.observe(target);
            }
        },
        loadVideo() {
            // src reale gia' presente in SSR (preload="metadata"/loading="lazy"):
            // qui si forza solo l'effettivo caricamento/play al momento dell'intersezione
            const bcPlayer = this.$refs.brightcovePlayer as any;
            if (bcPlayer && typeof bcPlayer.play === 'function') {
                bcPlayer.play();
            } else {
                const video = this.$refs.videoPlayer as HTMLVideoElement;

                if (video && this.cleanVideoUrl) {
                    // Configurazione forzata degli attributi di sicurezza iOS
                    video.muted = true;
                    video.setAttribute('muted', '');
                    video.setAttribute('playsinline', '');

                    video.load();
                    video.play()
                        .catch(() => {
                            // Se fallisce, iOS richiede una "spinta" dopo un micro-ritardo
                            setTimeout(() => {
                                video.play().catch(e => console.error("Fallimento definitivo:", e.message));
                            }, 100);
                        });
                }
            }
        },
        showBg() {
            this.isHovered = false
            setTimeout(() => {
                const video = this.$el.querySelector('video');
                if (video && !this.isAnimationsPaused) {
                    video.play();
                }

            }, 100)
        },
        hideBg() {
            this.isHovered = true
            const video = this.$el.querySelector('video');
            if (video) {
                video.pause();
            }
        },
        manageUrl() {
            const url = this.content.soleProfessionistiUrl
            const target = this.content.soleProfessionistiNewTab == '1' ? '_blank' : null;
            if (!url) return;
            if (target == '_blank') {
                window.open(url, target).focus();
            } else {
                location.href = url;
            }
        }
    }
})
